export const environment = {
  production: false,
  appEnv: 'development',
  appName: 'TransferSwap',
  supportEmail: 'support@transferswap.app',
  apiBaseUrl: 'https://dev-api.transferswap.app/api',
  providersApiBaseUrl: 'https://dev-api-providers.transferswap.app/api',
  fileApiBaseUrl: 'https://dev-api.transferswap.app/api',
  kushkiPublicKey: '229880aa157449189ff0eb6df1ba40eb',
  kushkiTest: true,
  cognitoRegion: 'us-east-1',
  cognitoUserPoolId: 'us-east-1_6aT6LQxVp',
  cognitoClientId: '552mp6foe2havqq3ihjcbo16l7',
  cognitoLoginEmailDomain: 'transferswap.app',
  enableDebugLogs: true,
  enableDevBadge: true,
};
